import { ReactElement, ReactNode } from 'react';

type LocationCardProps = {
  onClick: () => void;
  isOpen?: boolean;
  isLargeScreen?: boolean;
  header: string | ReactNode;
  className?: string;
  type?: string;
  variant?: 'default' | 'finder-mobile';
};

export default function AccordianBanner({
  onClick,
  isOpen,
  isLargeScreen = false,
  header,
  className = '',
  type = '',
  variant = 'default',
}: LocationCardProps): ReactElement {
  if (type === 'FAQ')
    return (
      <FAQAccordian
        onClick={onClick}
        isOpen={isOpen}
        header={header}
        className={className}
        isLargeScreen={isLargeScreen}
      />
    );

  if (variant === 'finder-mobile')
    return (
      <div
        role="button"
        className={`flex items-center justify-between border-b border-primary/20 px-4 py-4 cursor-pointer ${className}`}
        onClick={onClick}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
      >
        <div className="text-2xl text-primary-actual">{header}</div>
        {isLargeScreen ? null : (
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path d="M2 7H12" stroke="white" strokeWidth="2" strokeLinecap="round" />
              {isOpen ? null : (
                <path d="M7 2V12" stroke="white" strokeWidth="2" strokeLinecap="round" />
              )}
            </svg>
          </div>
        )}
      </div>
    );

  return (
    <div
      role="button"
      className={`flex items-center justify-between gap-4 cursor-pointer ${className}`}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex items-center text-left">
        <div className="bordered-heading bh-location-heading-item text-new-34 lg:text-4xl lg:leading-new-43 font-light text-primary-actual">
          {header}
        </div>
      </div>
      {isLargeScreen ? null : (
        <div className="h-calloutIcon flex items-center justify-center">
          <svg
            className={`transform text-highlight transition-transform duration-300 w-4 h-8 mr-1 md:mr-0 ${
              isOpen === true ? '-rotate-90' : 'rotate-0'
            }`}
            xmlns="http://www.w3.org/2000/svg"
            width="11"
            height="19"
            viewBox="0 0 11 19"
            fill="none"
          >
            <path
              d="M1.5 17.5L9.5 9.5L1.5 1.5"
              stroke="#0095A9"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
    </div>
  );
}

function FAQAccordian({ onClick, isOpen, header, className }: LocationCardProps): ReactElement {
  return (
    <div
      role="button"
      className={`flex items-center justify-between p-2 cursor-pointer ${className}`}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="text-lg text-primary-actual md:text-2xl">{header}</div>

      <div className="h-calloutIcon flex items-center justify-center">
        <div className="flex items-center justify-center p-1 h-8 w-8 bg-muted rounded-md">
          {isOpen && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="2"
              viewBox="0 0 16 2"
              fill="none"
            >
              <path
                d="M1 1H15"
                stroke="#00A3E0"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
          {!isOpen && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 5V19"
                stroke="#00A3E0"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 12H19"
                stroke="#00A3E0"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      </div>
    </div>
  );
}
